import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=06f5033e"
import script from "./CategoryTree.ts?vue&type=script&lang=ts&external"
export * from "./CategoryTree.ts?vue&type=script&lang=ts&external"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=06f5033e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCardText,VIcon,VTreeview})
